import React, { HTMLAttributes, useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  content: {
    overflow: 'hidden',
    maxHeight: 0,
    transition: 'max-height .3s',
  },
  contentOpening: ({ maxHeight }: { maxHeight?: number }) => ({
    maxHeight: maxHeight || 300,
  }),
  contentOpened: {
    overflow: 'visible',
  },
}));

interface Props extends HTMLAttributes<HTMLDivElement> {
  isOpen?: boolean;
  maxHeight?: number;
}

export const AnimatedSlidingDiv = ({
  className,
  isOpen,
  maxHeight,
  ...rest
}: Props) => {
  const classes = useStyles({ maxHeight });
  const prevIsOpen = useRef(isOpen);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  const [isCompletlyOpened, setOpened] = useState(isOpen);

  useEffect(() => {
    const clear = () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }
    };
    clear();

    if (isOpen && !prevIsOpen.current) {
      timeoutId.current = setTimeout(() => {
        setOpened(true);
      }, 300);

      return clear;
    } else if (!isOpen) {
      setOpened(false);
    }

    prevIsOpen.current = isOpen;
    return;
  }, [isOpen, prevIsOpen]);

  return (
    <div
      className={classnames(
        classes.content,
        {
          [classes.contentOpened]: isCompletlyOpened,
          [classes.contentOpening]: isOpen,
        },
        className,
      )}
      {...rest}
    />
  );
};
